import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCustomFieldSelect', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/custom_fields/select/select.html'),
        controller: 'SelectCustomFieldFormController',
        controllerAs: 'SelectCustomFieldFormCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            field: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/select/select.component.ts